var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_801_723",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0H11V9H20V1C20 0.447715 19.5523 0 19 0ZM1 4C0.447715 4 0 4.44772 0 5V11V13V19C0 19.5523 0.447715 20 1 20H8H9H15C15.5523 20 16 19.5523 16 19V11H9V4H1Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0H11V9H20V1C20 0.447715 19.5523 0 19 0ZM1 4C0.447715 4 0 4.44772 0 5V11V13V19C0 19.5523 0.447715 20 1 20H8H9H15C15.5523 20 16 19.5523 16 19V11H9V4H1Z",
    fill: "#2990FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0V-1H10V0H11ZM11 9H10V10H11V9ZM20 9V10H21V9H20ZM16 11H17V10H16V11ZM9 11H8V12H9V11ZM9 4H10V3H9V4ZM11 1H19V-1H11V1ZM12 9V0H10V9H12ZM20 8H11V10H20V8ZM19 1V9H21V1H19ZM19 1H21C21 -0.10457 20.1046 -1 19 -1V1ZM1 5V3C-0.10457 3 -1 3.89543 -1 5H1ZM1 11V5H-1V11H1ZM1 13V11H-1V13H1ZM1 19V13H-1V19H1ZM1 19H1H-1C-1 20.1046 -0.10457 21 1 21V19ZM8 19H1V21H8V19ZM9 19H8V21H9V19ZM15 19H9V21H15V19ZM15 19V21C16.1046 21 17 20.1046 17 19H15ZM15 11V19H17V11H15ZM9 12H16V10H9V12ZM8 4V11H10V4H8ZM1 5H9V3H1V5Z",
    fill: "#2990FB",
    mask: "url(#path-1-inside-1_801_723)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayground);
export default __webpack_public_path__ + "static/media/playground.b8cb46a50d3ef0b264c349f4fc88ba9e.svg";
export { ForwardRef as ReactComponent };